export default "__VITE_PUBLIC_ASSET__b2586d82__"